import { api } from "../api";

export const getNextInvoiceId = async () => {
  let url = "/clients/nextInvoiceId";
  return await api.get(url);
};

export const getClients = async () => {
  let url = "/clients";
  return await api.get(url);
};

export const getClientBillingContract = (clientId) => api.get(`/clients/${clientId}/billing-contract`);

export const getClientBillingContractHistory = (clientId) => api.get(`/clients/${clientId}/billing-contract-history`);

export const getClientBillingSummary = (clientId) => api.get(`/clients/${clientId}/billing-contract`);

export const createClientBillingContract = (clientId, data) => api.post(`/clients/${clientId}/billing-contract`, data);

export const markClientBillingCyclePaid = (clientId, cycleId) => api.patch(`/clients/${clientId}/billing-cycles/${cycleId}/paid`);

export const recordClientBillingCyclePayment = (clientId, cycleId, payment, file) => {
  const data = new FormData();
  data.append("amount", payment.amount);
  data.append("paidAt", payment.paidAt);
  data.append("paymentMethod", payment.paymentMethod);
  if (payment.notes) data.append("notes", payment.notes);
  if (file) data.append("file", file);
  return api.post(`/clients/${clientId}/billing-cycles/${cycleId}/payments`, data);
};

export const getClientBillingCyclePaymentReceipt = (clientId, cycleId, paymentId) =>
  api.get(`/clients/${clientId}/billing-cycles/${cycleId}/payments/${paymentId}/receipt`, { responseType: "blob" });

export const getClientSubscriptionContract = (clientId) => api.get(`/clients/${clientId}/billing-contract/document`, { responseType: "blob" });

export const uploadClientSignedContract = (clientId, contractId, file) => {
  const data = new FormData();
  data.append("file", file);
  return api.post(`/clients/${clientId}/billing-contracts/${contractId}/signed-document`, data);
};

export const getClientSignedContract = (clientId, contractId) => api.get(`/clients/${clientId}/billing-contracts/${contractId}/signed-document`, { responseType: "blob" });

export const deleteClient = async (clientId, engineerId) => {
  let url = `/clients/${clientId}`;
  return await api.delete(url, {
    engineerId: engineerId,
  });
};

export const updateClient = async (
  // clientId,
  // clientName,
  // cellPhone,
  // email,
  // powerDistributionCompanies,
  // isEngineer,
  // willReceiveAutomaticCharges,
  // communicationChannel,
  // invoiceId,
  // isActive,
  // cpf,
  // cnpj,
  // street,
  // number,
  // district,
  // addressDetails,
  // city,
  // state,
  // zipCode
  clientId,
  data
) => {
  let url = `/clients/${clientId}`;

  return await api.put(url, data);
};

export const createClient = async (
  // clientName,
  // cellPhone,
  // email,
  // powerDistributionCompanies,
  // isEngineer,
  // willReceiveAutomaticCharges,
  // communicationChannel,
  // invoiceId,
  // cpf,
  // cnpj,
  // priceTable,
  // street,
  // number,
  // district,
  // addressDetails,
  // city,
  // state,
  // zipCode
  data
) => {
  let url = `/clients`;

  return await api.post(url, data);
};

export const getServiceProvisionContract = async (
  clientName,
  clientType,
  clientDoc,
  street,
  number,
  district,
  city,
  state,
  zipCode,
  email
) => {
  let url = `/clients/service-contract`;

  return await api.post(
    url,
    {
      clientName,
      clientType,
      clientDoc,
      street,
      number,
      district,
      city,
      state,
      zipCode,
      email,
    },
    {
      responseType: "blob",
    }
  );
};
